import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/lib/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("renco_lang") || "en");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("renco_lang", l);
  }, []);

  const t = useCallback((key) => translations[lang]?.[key] ?? translations.en[key] ?? key, [lang]);

  const value = useMemo(() => ({ lang, changeLang, t }), [lang, changeLang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
